<template>
  <div class="projectSettings_main" :class="{'cn':version == '1','ja':version == '2'}" v-if="role != 2">
    <div class="cont_box">
      <div class="cont_left">
        <div class="text p1"><span class="i">*</span>{{ $t('App.projectSettings.text1') }}</div>
        <div class="form_box">
          <div class="form_item">
            <div class="icon icon4"></div>
            <div class="form_item_content">
              <el-input class="input1"  v-model="projectForm.name" :placeholder="$t('App.projectSettings.text2')"></el-input>
            </div>
          </div>
          <div class="form_item" >
            <div class="icon icon5" @click="lampLocationChange"></div>
            <div class="form_item_content">
              <el-input class="input1" v-model="projectForm.location" @change="projectChange()" :placeholder="$t('App.projectSettings.text3')"></el-input>
              <!-- <el-input v-model="projectForm.longitude" @keyup.native="projectAdd($event)"></el-input> -->
              <!-- <el-input v-model="projectForm.latitude" @keyup.native="projectAdd($event)"></el-input> -->
            </div>
          </div>
          <div class="form_item">
            <div class="icon icon6"></div>
            <div class="form_item_content">
              <el-input class="input1"  v-model="projectForm.description" :placeholder="$t('App.projectSettings.text4')"></el-input>
            </div>
          </div>
          <div class="form_item">
            <el-upload class="avatar-uploader" :data="imgUploadData" :action="actionImgUrl" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img class="icon" v-if="projectForm.image" :src="protocolStr+'//'+domainName+'/'+projectForm.image">
              <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
              <span class="icon btn" v-if="!projectForm.image"></span>
              <span style="color: rgba(255, 1, 1, 1);">(Background Image: Supported formats are JPG/JPEG/PNG, resolution 1080×1920, and the maximum file size is 10M.)</span>
            </el-upload>
            <!-- <div class="icon icon7"></div>
            <div class="icon btn"></div> -->
          </div>
        </div>
        <div class="btn_box">
          <div class="btn1" @click="logOut()">{{$t('App.exit')}}</div>
          <div class="btn3" @click="logDel()" v-loading="loading.delLoading" v-if="role == 0||role == 3&&projectPageId">{{ $t('App.delete') }}</div>
          <!-- <div class="btn3" @click="logDel()" v-loading="loading.delLoading">{{ $t('App.delete') }}</div> -->
          <div class="btn2" v-loading="loading.projectAdd" @click="projectAdd">{{$t('App.ok')}}</div>
        </div>
      </div>
      <!-- <div class="cont_right">
        <div class="text p1"><span class="i">*</span>{{ $t('App.projectSettings.text5') }}</div>
        <div class="flex_box">
          <div class="icon icon8"></div>
          <div class="icon btn"></div>
        </div>
        <div class="text p1"><span class="i">*</span>{{ $t('App.projectSettings.text6') }}</div>
        <div class="flex_box">
          <div class="icon icon9"></div>
          <div class="icon btn"></div>
        </div>
      </div> -->
    </div>
    
    <!-- 选择页面 -->
    <el-dialog :show-close="false" :visible.sync="selectVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="36.51rem" class="selection" >
      <el-radio-group style="display: grid;" v-model="getUserSettingInfoDateValue_" :disabled="true">
        <el-radio :disabled="getUserSettingInfoDate.sysStatus === 1" label="systemSetting">{{$t('App.status.text0')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.projectStatus === 1" label="projectSettings">{{$t('App.status.text1')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.gatewayStatus === 1" label="gatewayInput">{{$t('App.projectSettings.text5')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.deviceStatus === 1" label="controllerInput">{{$t('App.status.text2')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.groupStatus === 1" label="groupSetting">{{$t('App.status.text3')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.sceneStatus === 1" label="sceneSettingEdit">{{$t('App.status.text4')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.scheduleStatus === 1" label="schedule">{{$t('App.status.text5')}}</el-radio>
      </el-radio-group>
      <span  slot="footer" class="footer">
        <el-button @click="projectSelection()">Enter</el-button>
      </span>
    </el-dialog>

    <!-- 获取用户设置状态信息 -->
    <div class="project_completed" v-if="isShowprojectCompleted">
      <div class="bg"></div>
      <div class="form_box" >
        <div class="span">
          {{$t('App.text14')}}
        </div>
        <div class="btn_box2">
          <!-- <div class="btn1" @click="isShowLogout = false">{{$t('App.no')}}</div> -->
          <div class="btn2" @click="projectCompletedClose('controllerInput')">{{$t('App.ok')}}</div>
        </div>
      </div>
    </div>
    <!-- 经纬度定位 -->
    <div>
      <el-dialog width="75%" :title="$t('App.selectTargeting')" :visible.sync="dialogLocation" :before-close="dialogLocationClose" class="location_dialog" :close-on-click-modal="false" append-to-body>
        <el-form :model="maplnglatForm" ref="maplnglatForm" label-width="100px" class="maplnglatForm">
          <el-form-item :label="$t('App.jd')">
            <el-input v-model="maplnglatForm.lng" :controls="false" @change="maplnglatChange"></el-input>
          </el-form-item>
          <el-form-item :label="$t('App.wd')">
            <el-input v-model="maplnglatForm.lat" :controls="false" @change="maplnglatChange"></el-input>
          </el-form-item>
        </el-form>

        <div class="lampAmapWrapper_box">
          <!-- <el-input class="screenMap" v-model="screenMap" @keyup.native="screenMapKeyUp($event)" :placeholder="$t('App.searchPlaceholder')" clearable><i slot="prefix" class="scree-icon el-icon-search" @click="screenMapChange(screenMap)"></i>
          </el-input> -->
          <div class="screenMap_ul scrollbar_style" v-if="screenMapList.length>0" v-loading="loading.screenMapChange">
            <!-- v-if="item.location.length>0" -->
            <div class="screenMap_li" v-for="(item,index) in screenMapList" :key="index" @click="mapSearchSelect(item)" >
              <i class=""></i>
              <span class="span1" :title="item.name">{{item.name}}</span>
            </div>
          </div>
          <div class="map_icon_location" :title="'移动图标到地图中心'" @click="map_center_location()" v-if="version == 1"><i class="iconfont icon-location"></i></div>
          <div id="lampAmapWrapper">
          </div>
        </div>
        <span slot="footer" class="dialog-footer" >
          <el-button @click="dialogLocationClose()">{{$t("App.cancel")}}</el-button>
          <el-button type="primary" @click="projectLocationSave()">{{$t("App.save")}}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import allUrl from '../api/allUrl.js'
  import base from '../api/base.js'
  export default {
      name:'projectSettings',
      data () {
          return{
            protocolStr:'',
            domainName:'',
            isShowprojectCompleted: false,
            projectForm:{
              id:'',
              name:'',
              image:'',
              location:'',
              description:'',
              longitude: '', 
              latitude: '',
            },
            
            dialogImageUrl: '',
            actionImgUrl: '',
            imgUploadData: {
              username: '',
              clientType: '0',
              version: '0',
              token: '',
            },
            
            selectVisible: false,
            getUserSettingInfoDateValue_:'systemSetting',
            getUserSettingInfoDate :{
              sysStatus:'',
              projectStatus:'',
              gatewayStatus:'',
              deviceStatus:'',
              groupStatus:'',
              sceneStatus:'',
              scheduleStatus:'',
            },
            maplnglatForm:{
              lng:0,
              lat:0,
            },

            loading:{
              projectAdd:false,
              delLoading: false,
            },

            dialogLocation: false,
            screenMapList: [],
            inputText:'',
          }
      },
      computed:{
          ...mapGetters({
              token:'token',
              username:'username',
              version:'version',
              role: "role",

              projectName: "projectName",

              projectPageType:'projectPageType',
              projectPageId:'projectPageId',
              projectId:'projectId',

              remRatio:'remRatio',
              updateRemRatio:'updateRemRatio',

              countryId:'countryId',
              provinceId:'provinceId',
              cityId:'cityId',
              hotelId:'hotelId',
              headerIdStr:'headerIdStr',
              bjIndex:'bjIndex',

              projectUpdate: 'projectUpdate',
              themeType: 'themeType',
          }),
          // sensorFormModelName(){
          //     let name = '';
          //     for(let d of this.modelNav){
          //         if(d.id == this.sensorForm.model){
          //             name = d.name
          //         }
          //     }
          //     return name
          // }
      },
      components:{
          // 'sideBar':sideBar
      },
      beforeDestroy(){
      },
      mounted(){
        this.getUserSettingInfo();
        this.protocolStr = document.location.protocol;
        this.domainName = window.location.href.split("/")[2];
        if(this.domainName == 'localhost:8080' || this.domainName == '127.0.0.1:8080'){
            this.domainName = 'lighting.lampmind.com'
        }
        
        this.imgUploadData.username = this.username;
        this.imgUploadData.token = this.token;
        this.imgUploadData.version = this.version;
        this.actionImgUrl = allUrl.project.project_uploadImage;
        if(this.projectPageType == 'edit'){
          this.projectDetailsGet();
        }

        },
      methods:{
        // function formatCoordinate(coordinate){
        //   const degrees = Math.floor(coordinate);
        //   const minutes = Math.floor((coordinate - degrees) * 60);
        //   const seconds = Math.round(((coordinate - degrees - minutes / 60) * 3600) * 1000) / 1000;
        //   return `${degrees}°${minutes}'${seconds}"`;
        // },
        projectChange(){
       
          // const dmsRegex = /^Lng:\s*-?(1[0-7]\d|180|[0-9]?[0-9])°\s*[0-5]?[0-9]'\s*[0-5]?[0-9](\.\d+)?",\s*Lat:\s*-?(90|[0-8]?[0-9])°\s*[0-5]?[0-9]'\s*[0-5]?[0-9](\.\d+)?”$/;
          // console.log(ltstr,'12121212');

          let ltstr = this.projectForm.location;
          console.log(ltstr.slice(0,4),'-3-')
          if(this.version == '0') {
            let a = `Lng:`
            if (ltstr.slice(0,4) == a ) {
              let result =  ltstr.split(",");
              // console.log(result[0],'--8---')
              // console.log(result[1],'--7---')
              let lngresult =  result[0].slice(4);
              let latresult =  result[1].slice(4);
              console.log(lngresult,'--6---')
              console.log(latresult,'--5---')
              let DMSToDDD = function(str) {
              let du = str.split("°")[0];
              let fen = str.split("°")[1].split("'")[0];
              let miao = str.split("°")[1].split("'")[1].split('"')[0];
              let res = Math.abs(du) + (Math.abs(fen) / 60 + Math.abs(miao) / 3600);
              res = parseFloat(res).toFixed(6);
              return res;
              }
              this.projectForm.longitude = DMSToDDD(lngresult)
              this.projectForm.latitude = DMSToDDD(latresult)
              console.log(this.projectForm.latitude,'-99')
              console.log(this.projectForm.longitude,'--4---')
            } else {
              this.inputText = this.projectForm.location
              console.log(this.inputText,'--3636---')
            }
          } else {
            let a = `经度:`
            if (ltstr.slice(0,3) == a ) {
              let result =  ltstr.split(",");
              // console.log(result[0],'--8---')
              // console.log(result[1],'--7---')
              let lngresult =  result[0].slice(3);
              let latresult =  result[1].slice(3);
              console.log(lngresult,'--6---')
              console.log(latresult,'--5---')
              let DMSToDDD = function(str) {
              let du = str.split("°")[0];
              let fen = str.split("°")[1].split("'")[0];
              let miao = str.split("°")[1].split("'")[1].split('"')[0];
              let res = Math.abs(du) + (Math.abs(fen) / 60 + Math.abs(miao) / 3600);
              res = parseFloat(res).toFixed(6);
              return res;
              }
              this.projectForm.longitude = DMSToDDD(lngresult)
              this.projectForm.latitude = DMSToDDD(latresult)
              console.log(this.projectForm.latitude,'-99')
              console.log(this.projectForm.longitude,'--4---')
            } else {
              this.inputText = this.projectForm.location
              console.log(this.inputText,'--3636---')
            }

          }
          
          
        },
        maplnglatChange(){
          // this.maplnglatForm.lng
          // this.positionPicker
          if (this.version == '0') {

            console.log(this.maplnglatForm.lat,'-956---5--')
            let DMSToDDD = function(str) {
                let du = str.split("°")[0];
                let fen = str.split("°")[1].split("'")[0];
                let miao = str.split("°")[1].split("'")[1].split('"')[0];
                let res = Math.abs(du) + (Math.abs(fen) / 60 + Math.abs(miao) / 3600);
                res = parseFloat(res).toFixed(6);
                return res;
                // let coordinate_lng = res
            };
            let lat ='';
            let lng = '';
            let isTrue = true;
            try {
              lat = DMSToDDD(this.maplnglatForm.lat)
            } catch (e) {
              // console.log(e)
              let msg = this.version == '0' ? '纬度格式输入有误' : 'Latitude format input error.'
              this.$message({
                message: msg,
                type: 'warning'
              });
              isTrue = false;
            }
            try {
              lng = DMSToDDD(this.maplnglatForm.lng)
            } catch (e) {
              // console.log(e)
              let msg = this.version == '0' ? '经度格式输入有误' : 'Longitude format input error.'
              this.$message({
                message: msg,
                type: 'warning'
              });
              isTrue = false;
            }
            console.log(!isTrue)
            if(!isTrue){
              return
            }
            console.log(lat,'-99')

            // let num

            // if(lat = `${degrees}°${minutes}'${seconds}"`){

            //   this.positionPicker.position = new google.maps.LatLng(lat, lng)

            // }else{
            //   msg.warn(`${type === 'lat' ? '纬度' : '经度'}格式输入有误！`);
            // }

            

            this.positionPicker.position = new google.maps.LatLng(lat, lng)
          
            $('.projectLongitude' + this.projectPageId).text(this.maplnglatForm.lng);
            $('.projectLatitude' + this.projectPageId).html(this.maplnglatForm.lat);
            this.projectLongitude = this.maplnglatForm.lat;
            this.projectLatitude = this.maplnglatForm.lng;
            this.map.setCenter(new google.maps.LatLng(lat, lng));
            // console.log(this.positionPicker.position); 

            
            
          }else{
            // this.positionPicker.setPosition(new AMap.LngLat(parseFloat(this.maplnglatForm.lng), parseFloat(this.maplnglatForm.lat)));
            this.positionPicker.start([this.maplnglatForm.lng, this.maplnglatForm.lat]);
            // console.log(positionResult)
            $('.projectLongitude' + this.projectPageId).text(this.maplnglatForm.lng);
            $('.projectLatitude' + this.projectPageId).html(this.maplnglatForm.lat);
            // console.log(positionResult.position.lat,'-444444444444444')
            this.projectLongitude = this.maplnglatForm.lng;
            this.projectLatitude = this.maplnglatForm.lat;
            this.map.setCenter(new AMap.LngLat(parseFloat(this.maplnglatForm.lng), parseFloat(this.maplnglatForm.lat)));
          }
        },
        async initMap(center){
          let this_ = this;
          const { Map } = await google.maps.importLibrary("maps");
          const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

          this.map = new Map(document.getElementById("lampAmapWrapper"), {
            center: { lat: center.lat, lng: center.lng },
            zoom: 16,
            mapId: 'DEMO_MAP_ID'
          });

          const centerControlDiv = document.createElement("div");
          // centerControlDiv.className = "google_div_box"
          // const controlButton = document.createElement("button");
          const centerControl = createCenterControl(this.map);
          console.log(centerControl,'-444')
          centerControlDiv.appendChild(centerControl);
          // map.controls[google.maps.ControlPosition.TOP_CENTER].push(locationButton);
          this.map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(centerControlDiv);
          
          
          let bgColor = 'rgba(62,221,107,1)';
          let borderColor = 'rgba(62,221,107,0.2)';

          const priceTag = document.createElement('div');
          priceTag.className = 'lm_img_mover';
          
          priceTag.style.textAlign = "center";
          priceTag.style.border = '11px solid ' + borderColor;
          priceTag.style.textAlign = "center";
          priceTag.style.borderRadius = "50%";
          priceTag.style.cursor = "pointer";
          const controlDiv = document.createElement('DIV');
          controlDiv.style.textAlign = "center";
          controlDiv.style.background = bgColor;
          controlDiv.style.backgroundClip = "padding-box";
          controlDiv.style.border = "2px solid #fff";
          controlDiv.style.height = "8px";
          controlDiv.style.width = "8px";
          controlDiv.style.borderRadius = "50%";
          priceTag.appendChild(controlDiv);

          this.positionPicker = new AdvancedMarkerElement({
            map:this.map,
            position: new google.maps.LatLng(Number(center.lat), Number(center.lng)),
            gmpDraggable: true,
            content: priceTag
          });
          this.positionPicker.addListener("dragend", () => {
            const position = this.positionPicker.position;
            
            this_.projectLongitude = position.lng.toFixed(6);
            this_.projectLatitude = position.lat.toFixed(6);
            


            let coordinate_lng = position.lng.toFixed(6)
            coordinate_lng = ((coordinate_lng) => {
              const degrees = Math.floor(coordinate_lng);
              const minutes = Math.floor((coordinate_lng - degrees) * 60);
              const seconds = Math.round(((coordinate_lng - degrees - minutes / 60) * 3600) * 1000) / 1000;
              return `${degrees}°${minutes}'${seconds}"`;
            })(coordinate_lng);

            let coordinate_lat = position.lat.toFixed(6)
            coordinate_lat = ((coordinate_lat) => {
              const degrees = Math.floor(coordinate_lat);
              const minutes = Math.floor((coordinate_lat - degrees) * 60);
              const seconds = Math.round(((coordinate_lat - degrees - minutes / 60) * 3600) * 1000) / 1000;
              return `${degrees}°${minutes}'${seconds}"`;
            })(coordinate_lat);

            console.log(coordinate_lng,coordinate_lat,'96965--',position.lng.toFixed(6))
            
            $('.projectLongitude' + this_.projectPageId).text(coordinate_lng);
            $('.projectLatitude' + this_.projectPageId).html(coordinate_lat);
            
            this.maplnglatForm.lat = coordinate_lat
            this.maplnglatForm.lng = coordinate_lng

            
            console.log(this_.projectLongitude)
          });
          let JDstr = this.$t('App.jd');
          let WDstr = this.$t('App.wd');
          let time = setInterval(function () {
            console.log('--s-d-sd-')
            if ($('.lm_img_mover').length > 0) {
              let div = $('<div class="lamp_coordinate_en lamp_coordinate_' + this_.projectPageId + '"><span><span>' + JDstr + ' : <span class="projectLongitude' + this_.projectPageId + '">' + this_.projectLongitude + '</span></span><span>' + WDstr + ' : <span class="projectLatitude' + this_.projectPageId + '">' + this_.projectLatitude + '</span></span></span><i class="determine"></i><i class="cancel"></i></div>')
              $('.lm_img_mover').parent().append(div);

              // $('.lamp_coordinate_' + this_.projectPageId).children('i').mouseup(function (e) {
              //   let className = e.target.className.split(' ');
              //   if (className[0] == 'determine') {
              //     this_.lightControlData.longitude = this_.projectLongitude;
              //     this_.lightControlData.latitude = this_.projectLatitude;
              //     $('.lamp_coordinate_' + this_.projectPageId).css('display', 'none');
              //     $('.lamp_' + this_.projectPageId).unbind("mousedown");
              //     this_.amapWrapper = false;
              //   } else if (className[0] == 'cancel') {
              //     this_.amapWrapper = false;
              //   }
              // })
              clearInterval(time)
            }
          }, 1)
          /**
           * Creates a control that recenters the map on Chicago.
           */
          function createCenterControl() {
            const controlButton = document.createElement("button");
            // const centerControlDiv = document.createElement("div");
            // const centerControl = createCenterControl(initMap);
            controlButton.className = "google_Location_box"
            const controlUI = document.createElement('DIV');
            controlUI.className = "google_Location"

            controlButton.appendChild(controlUI);
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('viewBox', '25 25 50 50');
            svg.setAttribute('class', 'circular');
            svg.setAttribute('style', 'display:none');
            const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            circle.setAttribute('cx', '50');
            circle.setAttribute('cy', '50');
            circle.setAttribute('r', '20');
            circle.setAttribute('fill', 'none');
            circle.setAttribute('class', 'path');

            svg.appendChild(circle);
            controlButton.appendChild(svg);
            // Setup the click event listeners: simply set the map to Chicago.
            // let infoWindow;
            controlButton.addEventListener("click", () => {
              console.log(navigator.geolocation)
              $('.google_Location').css('display', 'none');
              $('.google_Location_box .circular').css('display', 'inline-block');
              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                  (position) => {
                    const pos = {
                      lat: position.coords.latitude,
                      lng: position.coords.longitude,
                    };
                    console.log(pos)
                    this_.map.setCenter(pos);
                    $('.google_Location').css('display', 'inline-block');
                    $('.google_Location_box .circular').css('display', 'none');
                  },
                  () => {
                    handleLocationError(true, this_.map.getCenter());
                  },
                );
              } else {
                // Browser doesn't support Geolocation
                handleLocationError(false, this_.map.getCenter());
              }
            });
            console.log(controlButton,'-666555')
            return controlButton;
          }
          
          function handleLocationError(browserHasGeolocation, pos) {
            $('.google_Location').css('display', 'inline-block');
            $('.google_Location_box .circular').css('display', 'none');
            this_.$message({
              showClose: true,
              message: 'seek failed',
              type: 'warning'
            });
            console.log(browserHasGeolocation,pos,'--951')
          }
          
          

        },
        projectLocationSave () {
            this.projectForm.longitude = Number(this.projectLongitude)
            this.projectForm.latitude = Number(this.projectLatitude)
            
            let coordinate_lng = this.projectForm.longitude
            coordinate_lng = ((coordinate_lng) => {
              const degrees = Math.floor(coordinate_lng);
              const minutes = Math.floor((coordinate_lng - degrees) * 60);
              const seconds = Math.round(((coordinate_lng - degrees - minutes / 60) * 3600) * 1000) / 1000;
              return `${degrees}°${minutes}'${seconds}"`;
            })(coordinate_lng);

            let coordinate_lat = this.projectForm.latitude
            coordinate_lat = ((coordinate_lat) => {
              const degrees = Math.floor(coordinate_lat);
              const minutes = Math.floor((coordinate_lat - degrees) * 60);
              const seconds = Math.round(((coordinate_lat - degrees - minutes / 60) * 3600) * 1000) / 1000;
              return `${degrees}°${minutes}'${seconds}"`;
            })(coordinate_lat);

            console.log(coordinate_lng,coordinate_lat,'95--')


            this.projectForm.location =this.$t('App.jd') +':'+ coordinate_lng +','+this.$t('App.wd') +':'+ coordinate_lat
            console.log(this.projectForm.location,'-11556')
            if (this.map) {
              // console.log(this.map)
              // this.map.remove();
              this.map = null;
            }
            this.dialogLocation = false;
        },
        mapSearchSelect (obj) {
          if (obj.location) {
            this.positionPicker.start(obj.location.split(','));
            this.mapSearchLocation = obj.location.split(',');
            console.log(obj.location.split(','))
          }
          this.screenMap = obj.name;
          this.screenMapList = [];
        },
        map_center_location () {
          let center = this.map.getCenter();
          console.log()
          this.positionPicker.start([center.lng, center.lat]);
          this.mapSearchLocation = [center.lng, center.lat];
        },

        dialogLocationClose (done) {
          // if (this.offLine == 1) {
          //   if (this.map) {
          //     console.log(this.map)
          //     this.map.remove();
          //   }
          // }
          if (done) {
            try {
              done()
            } catch (e) {
              console.log('e')
            }
          } else {
            this.dialogLocation = false;
          }
        },
        lampLocationChange(){
          console.log(this.inputText,'-666')
          if(!this.inputText){
            this.lampLocation();
            console.log('-9-9-99')
          }else {
            this.GeocoderChange();
            console.log('-9-9-')
          }
          
        },
        GeocoderChange(){
          console.log(this.inputText,'-5555666')
          if(this.version == '0') {
            let geocoder = new google.maps.Geocoder();
            geocoder
            .geocode({ address: this.inputText })
            .then((result) => {
              const { results } = result;
              console.log(results[0].geometry.location.lat(),'-965134---59')
              this.Lat = results[0].geometry.location.lat()
              this.Lng = results[0].geometry.location.lng()
              console.log(this.Lat,'----59')

              if(this.Lat) {
                this.projectForm.longitude = results[0].geometry.location.lng()
                this.projectForm.latitude = results[0].geometry.location.lat()
              }
              console.log(this.projectForm.longitude,'----58')

              this.lampLocation();
            })
            .catch(() => {
              this_.$message({
                showClose: true,
                message: 'No result was found for this.',
                type: 'error'
              });
            });
          } else {
            let geocoder = new AMap.Geocoder({city: this.inputText})
            let address  = this.inputText;
            let this_ = this
            geocoder.getLocation(address, function(status, result) {
              if (status === 'complete' && result.geocodes.length) {
                let lnglat = result.geocodes[0].location
                console.log(lnglat,'-1-2-3--')
                this_.Lat = result.geocodes[0].location.lat
                this_.Lng = result.geocodes[0].location.lng
                if(lnglat) {
                  this_.projectForm.longitude = this_.Lng
                  this_.projectForm.latitude = this_.Lat
                }

                this_.lampLocation();
              }

            })
          }
          // let inputText = '';
          // this.inputText = null
          this.inputText = ''
          console.log(this.inputText,'-9651---')
        },
        //获取地图
        lampLocation () {
          let this_ = this;
          this.dialogLocation = true;

          let JDstr = this.$t('App.jd');
          let WDstr = this.$t('App.wd');
          let mapId = '';
          // if(type == 'batchChangeLocation'){
          //   mapId = 'lampAmapWrapper1';
          //   this.projectLongitude = Number(this.batchChangeLocationForm.longitude)
          //   this.projectLatitude = Number(this.batchChangeLocationForm.latitude)
          // }else{

            mapId = 'lampAmapWrapper';
            let coordinate_lng = this.projectForm.longitude
            coordinate_lng = ((coordinate_lng) => {
              const degrees = Math.floor(coordinate_lng);
              const minutes = Math.floor((coordinate_lng - degrees) * 60);
              const seconds = Math.round(((coordinate_lng - degrees - minutes / 60) * 3600) * 1000) / 1000;
              return `${degrees}°${minutes}'${seconds}"`;
            })(coordinate_lng);

            let coordinate_lat = this.projectForm.latitude
            coordinate_lat = ((coordinate_lat) => {
              const degrees = Math.floor(coordinate_lat);
              const minutes = Math.floor((coordinate_lat - degrees) * 60);
              const seconds = Math.round(((coordinate_lat - degrees - minutes / 60) * 3600) * 1000) / 1000;
              return `${degrees}°${minutes}'${seconds}"`;
            })(coordinate_lat);

            console.log(coordinate_lng,coordinate_lat,'95--')
            this.maplnglatForm.lng = coordinate_lng
            this.maplnglatForm.lat = coordinate_lat

            this.projectLongitude = Number(this.projectForm.longitude);
            this.projectLatitude = Number(this.projectForm.latitude);
          // }maplnglatForm.lng

          if (isNaN(this.projectLongitude) || isNaN(this.projectLatitude) || this.projectLongitude > 180 || this.projectLongitude < -180 || this.projectLatitude > 90 || this.projectLatitude < -90) {
            this.$message({
              showClose: true,
              message: this.$t('App.message.text45'),
              type: 'warning'
            });
            this.dialogLocation = false;
            this.map = null;
            return
          }
          this.$nextTick(function () {
            console.log('119999999999212121')
            $('#'+mapId).css('height', $(window).height() * 0.5 + 'px');
            if (this.version == '0') {
              // console.log(google)
              let lat = 0;
              let lng = 0;
              if (!isNaN(this.projectLongitude) && !isNaN(this.projectLatitude) && !(this.projectLongitude == 0 && this.projectLongitude == 0)) {
                lat = this.projectLatitude;
                lng = this.projectLongitude;
                this_.mapDWIsTrue = false;
                // this.map = new google.maps.Map(document.getElementById(mapId), {
                //   center: { lat: this.projectLatitude, lng: this.projectLongitude },
                //   zoom: 16,
                //   gestureHandling: 'greedy',
                //   streetViewControl: false,
                //   mapTypeControlOptions: {
                //     style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                //     position: google.maps.ControlPosition.RIGHT_TOP
                //   },
                //   mapTypeId: google.maps.MapTypeId.ROADMAP,
                // });
                this.initMap({ lat: this.projectLatitude, lng: this.projectLongitude });
                // console.log(this.Lat,'----6---')

                console.log('---------1',lat,lng)
              } else {
                this_.mapDWIsTrue = true;
                // this.map = new google.maps.Map(document.getElementById(mapId), {
                //   center: { lat: 0, lng: 0 },
                //   zoom: 16,
                //   gestureHandling: 'greedy',
                //   streetViewControl: false,
                //   mapTypeControlOptions: {
                //     style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                //     position: google.maps.ControlPosition.RIGHT_TOP
                //   },
                //   mapTypeId: google.maps.MapTypeId.ROADMAP,
                // });
                this.initMap({ lat: 0, lng: 0 } );
              }
              // console.log(Number(lat),Number(lng),'465656565')
              // // this.geocoder = new google.maps.Geocoder();
              // // let bgColor = 'rgba(62,221,107,1)';
              // // let borderColor = 'rgba(62,221,107,0.2)';
              
              // this_.positionPicker = new AdvancedMarkerElement({
              //   map:this_.map,
              //   position: new google.maps.LatLng(Number(lat), Number(lng)),
              //   draggable: true,
              //   // icon:'../img/open_light.png'
              //   // content: '<div class="lm_img_mover" style="text-align:center;border:11px solid ' + borderColor + '; border-radius:50%;cursor:pointer;"><div style="text-align:center;background:' + bgColor + ';background-clip: padding-box;border:2px solid #fff; height: 8px; width: 8px; border-radius:50%;"></div></div>'
              // });
              // this_.positionPicker.setLabel({
              //   className: 'markerClass',
              //   text:this_.$t('App.jd') +':'+ lng +','+this_.$t('App.wd') +':'+ lat
              // })
              
              // google.maps.event.addListener(this_.positionPicker, 'dragend', function (e) {
              //   // console.log(e.latLng)
              //   this_.projectLongitude = e.latLng.lng().toFixed(8);
              //   this_.projectLatitude = e.latLng.lat().toFixed(8);
                
              //   this_.positionPicker.setLabel({
              //     className: 'markerClass',
              //     text:this_.$t('App.jd') +':'+ this_.projectLongitude +','+this_.$t('App.wd') +':'+ this_.projectLatitude
              //   })
              // })
              // this_.positionPicker = new RichMarker({
              //   position: new google.maps.LatLng(Number(lat), Number(lng)),
              //   map: this_.map,
              //   draggable: true,
              //   content: '<div class="lm_img_mover" style="text-align:center;border:11px solid ' + borderColor + '; border-radius:50%;cursor:pointer;"><div style="text-align:center;background:' + bgColor + ';background-clip: padding-box;border:2px solid #fff; height: 8px; width: 8px; border-radius:50%;"></div></div>'
              // })

              // var controlDiv = document.createElement('DIV');
              // controlDiv.className = "google_Location_box"
              // var controlUI = document.createElement('DIV');
              // controlUI.className = "google_Location"
              // controlDiv.appendChild(controlUI);
              // var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
              // svg.setAttribute('viewBox', '25 25 50 50');
              // svg.setAttribute('class', 'circular');
              // svg.setAttribute('styel', 'display:none');
              // var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
              // circle.setAttribute('cx', '50');
              // circle.setAttribute('cy', '50');
              // circle.setAttribute('r', '20');
              // circle.setAttribute('fill', 'none');
              // circle.setAttribute('class', 'path');

              // svg.appendChild(circle);
              // controlDiv.appendChild(svg);
              
              // addEventListener(controlDiv, function (){
              // google.maps.event.addDomListener(controlDiv, 'click', function () {
              //   console.log(controlDiv,'11----------------------11')
              //   if (navigator.geolocation && this_.googleMapLocattion) {
              //     this_.googleMapLocattion = false;
                  
              //     $('.google_Location').css('display', 'none');
              //     $('.google_Location_box .circular').css('display', 'inline-block');
              //     let options = {
              //       enableHighAccuracy: false,
              //       timeout: 3000,
              //       maximumAge: 3000
              //     }
              //     // function successHandler (position) {
              //     //   this_.map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
              //     //   lat = position.coords.latitude;
              //     //   lng = position.coords.longitude;
              //     //   this_.positionPicker.setPosition(new google.maps.LatLng(position.coords.latitude, position.coords.longitude))
              //     //   this_.googleMapLocattion = true;
              //     //   $('.google_Location').css('display', 'inline-block');
              //     //   $('.google_Location_box .circular').css('display', 'none');
              //     //   console.log('---------1--------', position)
              //     // }
              //     // function errorHandler (error) {
              //     //   console.log('------2-----------', error)
              //     //   this_.googleMapLocattion = true;
              //     //   $('.google_Location').css('display', 'inline-block');
              //     //   $('.google_Location_box .circular').css('display', 'none');
              //     //   this_.$message({
              //     //     showClose: true,
              //     //     message: 'seek failed',
              //     //     type: 'warning'
              //     //   });
              //     // }
              //     navigator.geolocation.getCurrentPosition(this_.successHandler, this_.errorHandler, options)
              //   }
              // });
              // this_.map.controls[google.maps.ControlPosition.BOTTOM_RIGHT].push(controlDiv);

              console.log(this_.screenMap,this_.mapDWIsTrue,'----------')
              // if (this_.screenMap && this_.mapDWIsTrue) {
              //   this_.geocoder.geocode({ address: this_.screenMap }, function (status, result) {
              //     // console.log(status, result)
              //     if (result === 'OK') {
              //       this_.mapDWIsTrue = false;
              //       lng = status[0].geometry.location.lng();
              //       lat = status[0].geometry.location.lat();
              //       // console.log(lng,lat)
              //       this_.positionPicker.setPosition(new google.maps.LatLng(lat, lng))
              //       this_.map.setCenter(new google.maps.LatLng(lat, lng));
              //     } else {
              //       this_.mapDWIsTrue = true;
              //       this_.$message({
              //         showClose: true,
              //         message: 'Unrecognized, please change the search content',
              //         type: 'warning'
              //       });
              //     }
              //     this.function_navigator(this_, lat, lng);
              //   })
              // } else {
              //   console.log('----')
              //   this.function_navigator(this_, lat, lng);
              // }
              // console.log(navigator.geolocation , this_.mapDWIsTrue)

              // google.maps.event.addListener(this_.positionPicker, "position_changed", function () {

              //   $('.projectLongitude' + this_.projectPageId).text(this.getPosition().lng().toFixed(10));
              //   $('.projectLatitude' + this_.projectPageId).html(this.getPosition().lat().toFixed(10));
              //   this_.projectLongitude = this.getPosition().lng().toFixed(10);
              //   this_.projectLatitude = this.getPosition().lat().toFixed(10);
              // })
              // let time = setInterval(function () {
              //   console.log('--s-d-sd-')
              //   if ($('.lm_img_mover').length > 0) {
              //     let div = $('<div class="lamp_coordinate_en lamp_coordinate_' + this_.projectPageId + '"><span><span>' + JDstr + ' : <span class="projectLongitude' + this_.projectPageId + '">' + this_.projectLongitude + '</span></span><span>' + WDstr + ' : <span class="projectLatitude' + this_.projectPageId + '">' + this_.projectLatitude + '</span></span></span><i class="determine"></i><i class="cancel"></i></div>')
              //     $('.lm_img_mover').parent().append(div);

              //     $('.lamp_coordinate_' + this_.projectPageId).children('i').mouseup(function (e) {
              //       let className = e.target.className.split(' ');
              //       if (className[0] == 'determine') {
              //         this_.lightControlData.longitude = this_.projectLongitude;
              //         this_.lightControlData.latitude = this_.projectLatitude;
              //         $('.lamp_coordinate_' + this_.projectPageId).css('display', 'none');
              //         $('.lamp_' + this_.projectPageId).unbind("mousedown");
              //         this_.amapWrapper = false;
              //       } else if (className[0] == 'cancel') {
              //         this_.amapWrapper = false;
              //       }
              //     })
              //     clearInterval(time)
              //   }
              // }, 1)

              // console.log(document.getElementById,'987878--')
              // service = new google.maps.visualization.PlacesService(map);
              // service.findPlaceFromQuery(request, (results, status) => {
              //   if (status === google.maps.visualization.PlacesServiceStatus.OK && results) {
              //     for (let i = 0; i < results.length; i++) {
              //       createMarker(results[i]);
              //     }

              //     map.setCenter(results[0].geometry.location);
              //   }
              // });
              
            } else {
              console.log('11121')
              // console.log(this.map)
              // if(this.map){
              //     console.log(this.map)
              //     this.map.destroy()
              //     this.map = null;
              // }
              if (!isNaN(this.projectLongitude) && !isNaN(this.projectLatitude)) {
                console.log('111')
                this.map = new AMap.Map(mapId, {
                  resizeEnable: true,
                  lang: this_.version == '0' ? "en" : 'zh_cn', //可选值：en，zh_en, zh_cn
                  center: [this.projectLongitude, this.projectLatitude],
                  zoom: 18,
                });
              } else {
                this.map = new AMap.Map(mapId, {
                  resizeEnable: true,
                  // center:[114,30],
                  lang: this_.version == '0' ? "en" : 'zh_cn', //可选值：en，zh_en, zh_cn
                  zoom: 18,
                });
              }

              // if (this.lampDialogTitle == this.viewLampText) {
              //   var marker = new AMap.Marker({
              //     position: [this.projectLongitude, this.projectLatitude],
              //     icon: '../img/open_light.png',
              //     offset: new AMap.Pixel(-17, -17),
              //   });
              //   this.map.add(marker);
              //   let time = setInterval(function () {
              //     if ($('.amap-marker').children('.amap-icon').children('img').parent().length > 0) {
              //       let div = $('<div class="lamp_coordinate lamp_coordinate_' + this_.projectPageId + '"><span><span>' + JDstr + ' : <span class="projectLongitude' + this_.projectPageId + '">0</span></span><span>' + WDstr + ' : <span class="projectLatitude' + this_.projectPageId + '">0</span></span></span></div>')
              //       $('.amap-marker').children('.amap-icon').children('img').parent().append(div);
              //       $('.projectLongitude' + this_.projectPageId).text(this_.projectLongitude);
              //       $('.projectLatitude' + this_.projectPageId).html(this_.projectLatitude);
              //       clearInterval(time)
              //     }
              //   }, 1)
              //   return
              // }
              AMapUI.loadUI(['misc/PositionPicker'], function (PositionPicker) {
                this_.positionPicker = new PositionPicker({
                  mode: 'dragMarker',
                  map: this_.map,
                  iconStyle: { //自定义外观
                    url: './img/open_light.png',
                    ancher: [17, 17],
                    size: [34, 34],
                  }
                });

                this_.positionPicker.on('success', function (positionResult) {
                  $('.projectLongitude' + this_.projectPageId).text(positionResult.position.lng);
                  $('.projectLatitude' + this_.projectPageId).html(positionResult.position.lat);
                  console.log(positionResult.position.lat,'-444444444444444')
                  this_.projectLongitude = positionResult.position.lng;
                  this_.projectLatitude = positionResult.position.lat;
                  this_.maplnglatForm.lat = positionResult.position.lat
                  this_.maplnglatForm.lng = positionResult.position.lng
                });
                this_.positionPicker.on('fail', function (positionResult) {
                  console.log(positionResult, '-123---')
                });
                this_.map.addControl(new AMap.ToolBar({
                  liteStyle: true
                }))
                if (this_.projectLongitude && this_.projectLatitude && !(this_.projectLongitude > 180 || this_.projectLongitude < -180 || this_.projectLatitude > 90 || this_.projectLatitude < -90)) {
                  this_.positionPicker.start([this_.projectLongitude, this_.projectLatitude]);
                  // this_.mapDWIsTrue = false;
                } else {
                  if (this_.screenMap) {
                    // this_.mapDWIsTrue = false;
                    if (this_.mapSearchLocation.length == 2) {
                      this_.positionPicker.start(this_.mapSearchLocation)
                    } else {
                      this_.positionPicker.start()
                    }
                  } else {
                    // this_.mapDWIsTrue = true;
                    this_.positionPicker.start()
                  }
                }
              })
              this.geocoder = new AMap.Geocoder({
              });

              let time = setInterval(function () {
                if ($('.amap-marker').children('.amap-marker-content').children('img').parent().length > 0) {
                  let div = $('<div class="lamp_coordinate lamp_coordinate_' + this_.projectPageId + '"><span><span>' + JDstr + ' : <span class="projectLongitude' + this_.projectPageId + '">0</span></span><span>' + WDstr + ' : <span class="projectLatitude' + this_.projectPageId + '">0</span></span></span></div>')
                  $('.amap-marker').children('.amap-marker-content').children('img').parent().append(div);
                  $('.projectLongitude' + this_.projectPageId).text(this_.projectLongitude);
                  $('.projectLatitude' + this_.projectPageId).html(this_.projectLatitude);
                  clearInterval(time)
                }
              }, 1)

              
            }
          })

          console.log(this.inputText,'-i--')
        },
        function_navigator (this_) {
          if (navigator.geolocation && this_.mapDWIsTrue && this_.googleMapLocattion) {
            this_.googleMapLocattion = false;
            let time1 = setInterval(function () {
              if ($('.google_Location').length > 0 && $('.google_Location_box .circular').length > 0) {
                $('.google_Location').css('display', 'none');
                $('.google_Location_box .circular').css('display', 'inline-block');
                clearInterval(time1);
              }
            }, 1)
            let options = {
              enableHighAccuracy: false,
              timeout: 3000,
              maximumAge: 3000
            }
            navigator.geolocation.getCurrentPosition(this.successHandler, this.errorHandler, options)

          }
        },
        
        successHandler (position) {
          this_.map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
          lat = position.coords.latitude;
          lng = position.coords.longitude;
          console.log(lat,lng,'-11111')
          this_.positionPicker.setPosition(new google.maps.LatLng(position.coords.latitude, position.coords.longitude))
          this_.googleMapLocattion = true;
          let time2 = setInterval(function () {
            if ($('.google_Location').length > 0 && $('.google_Location_box .circular').length > 0) {
              $('.google_Location').css('display', 'inline-block');
              $('.google_Location_box .circular').css('display', 'none');
              clearInterval(time1);
              clearInterval(time2);
            }
          }, 1)
          // console.log('---------1--------')
        },
        errorHandler () {
          console.log('------2-----------')
          this_.googleMapLocattion = true;
          let time3 = setInterval(function () {
            if ($('.google_Location').length > 0 && $('.google_Location_box .circular').length > 0) {
              $('.google_Location').css('display', 'inline-block');
              $('.google_Location_box .circular').css('display', 'none');
              clearInterval(time1);
              clearInterval(time3);
            }
          }, 1)
          this_.$message({
            showClose: true,
            message: 'seek failed',
            type: 'warning'
          });
        },
        confirmSelection() {
          this.getUserSettingInfo(data => {
            if (data.isTrue) {
              this.selectVisible = true;
            }
          });
        },
        projectSelection(){
          
          this.$emit('pageTypeFun', this.getUserSettingInfoDateValue_)
          this.selectVisible = false;
        },
        logDel(){
          this.$confirm(
              this.$t('App.message.text3'), this.$t('App.message.text4'), {
                  confirmButtonText: this.$t('App.message.text5'),
                  cancelButtonText: this.$t('App.message.text6'),
                  type: 'warning'
              }
          ).then(() => {
            this.$prompt(this.$t('App.login.text4'), this.$t('App.message.text4'), {
              confirmButtonText: this.$t('App.message.text5'),
              cancelButtonText: this.$t('App.message.text6'),
              inputType: 'password'
            }).then(({ value }) => {
                
                let time = new Date();
                var client_key = navigator.userAgent +time;
                base.ajax_post(
                  allUrl.login.sureLogin,
                  {
                    username: this.username,
                    password: value,
                    version: this.version,
                    clientKey: client_key,
                  },
                  {},
                  () => {
                    this.loading.delLoading = true;
                    base.ajax_post(
                      allUrl.project.project_del,
                      {
                        client_key:this.client_key,
                        token:this.token,
                        id:this.projectPageId,
                        username: this.username,
                      },
                      {},
                      data =>{
                        this.$message({
                            showClose: true,
                            message: data.msg,
                            type: 'success'
                        });
                        this.loading.delLoading = false;
                        this.projectNavList('del');
                      },
                    this,()=>{
                      this.loading.delLoading = false;
                    })
                  },
                  this,(data)=>{
                    this.$message({
                      showClose: true,
                      message: data.msg,
                      type: 'info'
                    });
                  }
                )
      
            }).catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('App.message.text7')
              });
            });
          }).catch(() => {
              this.$message({
                  type: 'info',
                  message: this.$t('App.message.text7')
              }); 
          });
        },
        projectCompletedClose(){
          this.isShowprojectCompleted = false
          this.$emit('pageTypeFun','controllerInput')
        },
        //获取用户设置状态信息
        getUserSettingInfo(callback) {
          // this.selectVisible = true;
          base.ajax_post(
            allUrl.user.user_getUserSettingInfo,
            {
            username: this.username,
            version: this.version,
            token:this.token,
            },
            {},
            data => {
              this.getUserSettingInfoDate = data.data;
              data.isTrue = false;
              if(this.getUserSettingInfoDate.sysStatus == 0){
                this.getUserSettingInfoDateValue_ = 'systemSetting'
                data.isTrue = true
              } else if(this.getUserSettingInfoDate.projectStatus == 0){
                this.getUserSettingInfoDateValue_ = 'projectSettings'
                data.isTrue = true
              }else if(this.getUserSettingInfoDate.gatewayStatus == 0){
                this.getUserSettingInfoDateValue_ = 'gatewayInput'
                data.isTrue = true
              } else if(this.getUserSettingInfoDate.deviceStatus == 0){
                this.getUserSettingInfoDateValue_ = 'controllerInput'
                data.isTrue = true
              } else if(this.getUserSettingInfoDate.groupStatus == 0){
                this.getUserSettingInfoDateValue_ = 'groupSetting'
                data.isTrue = true
              } else if(this.getUserSettingInfoDate.sceneStatus == 0){
                this.getUserSettingInfoDateValue_ = 'sceneSettingEdit'
                data.isTrue = true
              }else if(this.getUserSettingInfoDate.scheduleStatus == 0){
                this.getUserSettingInfoDateValue_ = 'schedule'
                data.isTrue = true
              }
              if(callback){
                callback(data)
              }
            },
            this
          )
        },
        handleAvatarSuccess (res, file) {
          if(res.code == '00000'){
            this.projectForm.image = file.response.data.image;
          }else{
            this.$message.error(res.msg);
          }
          // console.log(file,res)
        },
        beforeAvatarUpload (file) {
          const isJPG = file.type === 'image/jpeg';
          const isPNG = file.type === 'image/png';

          if (!isJPG && !isPNG) {
            this.$message.error(this.$t('App.message.imgType'));
          }
          return isJPG || isPNG;
        },
        projectDetailsGet() {
          if(!this.projectPageId){
            for(let key in this.projectForm){
              this.projectForm[key] = ''
            }
            return
          }
          base.ajax_post(
            allUrl.project.project_details,
            {
              username: this.username,
              version: this.version,
              token:this.token,
              id:this.projectPageId
            },
            {},
            data => {
              console.log(data)
              for(let key in this.projectForm){
                if(data.data[key]){
                  this.projectForm[key] = data.data[key]
                }else{
                  this.projectForm[key] = ''
                }
              }
            },
            this
          )
        },
        //退出登录跳转登录页
        logOut(){
          this.$emit('pageTypeFun', '')
        },
        //跳转首页
        pageTypeFun () {
          this.$store.commit('projectPageTypeFun', {
            projectPageType: '',
            projectPageId:'',
          })
          this.$emit('pageTypeFun', '')
        },
        projectAdd() {
          if(this.projectPageId){
            this.projectUpdateFun()
            return
          }
          if(this.loading.projectAdd){
            return
          }
          this.loading.projectAdd = true;
          base.ajax_post(
            allUrl.project.project_add,
            {
              username: this.username,
              version: this.version,
              token:this.token,
              name: this.projectForm.name,
              location: this.projectForm.location,
              description: this.projectForm.description,
              image: this.projectForm.image,
              longitude: this.projectForm.longitude,
              latitude: this.projectForm.latitude,
            },
            {},
            data => {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'success'
              });
              this.loading.projectAdd = false;
              this.projectNavList('add');
              // this.$emit('pageTypeFun', '')
              // console.log(this.getUserSettingInfoDate.projectStatus,'--1-5-6-444')
              if(this.getUserSettingInfoDate.projectStatus == 0){
                this.confirmSelection()
              }
              let bjIndex = this.bjIndex
              this.$store.commit('bjIndexSelectFun', {
                bjIndex: bjIndex + 1,
              })
            },
            this,()=>{
              this.loading.projectAdd = false;
            }
          )
        },
        projectUpdateFun() {
          if(this.loading.projectAdd){
            return
          }
          this.loading.projectAdd = true;
          base.ajax_post(
            allUrl.project.project_update,
            {
              username: this.username,
              version: this.version,
              token:this.token,
              id:this.projectPageId,
              name: this.projectForm.name,
              location: this.projectForm.location,
              description: this.projectForm.description,
              image: this.projectForm.image,
              longitude: this.projectForm.longitude,
              latitude: this.projectForm.latitude,
            },
            {},
            data => {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'success'
              });
              this.loading.projectAdd = false;
              this.projectNavList()
              this.projectDetailsGet();
              this.$emit('pageTypeFun', '')
              let bjIndex = this.bjIndex
              // this.$emit('pageTypeFun', '')
              this.$store.commit('bjIndexSelectFun', {
                bjIndex: bjIndex + 1,
              })
            },
            this,()=>{
              this.loading.projectAdd = false;
            }
          )
        },
        projectNavList(type) {
          base.ajax_post(
            allUrl.project.project_nav,
            {
              username: this.username,
              version: this.version,
              token:this.token,
            },
            {},
            data => {
              this.$store.commit('provinceNavListSelectFun',{
                provinceNavList:data.data,
              })
              if(data.data.length==0){
                this.$store.commit("projectSelectFun", {
                  projectId: null,
                  projectName: null,
                });
                if(type == 'del'){
                  this.$store.commit("projectPageTypeFun", {
                    projectPageType: "add",
                    projectPageId: "",
                  });
                  for(let key in this.projectForm){
                    this.projectForm[key] = null;
                  }
                }
              }
              console.log(!this.projectId||type,this.projectUpdate)
              if (!this.projectId||type) {
                if(data.data.length>0){
                  this.$store.commit("projectSelectFun", {
                    projectId: data.data[0].id,
                    projectName: data.data[0].name,
                  });
                  if(type == 'del'){
                    this.$emit('pageTypeFun', '')
                  }
                }
                this.$store.commit('projectUpdateFun', {
                  projectUpdate: this.projectUpdate+1,
                })
              }
              if(this.projectId){
                for(let d of data.data){
                  if(d.id == this.projectId){
                    this.$store.commit("projectSelectFun", {
                      projectId: d.id,
                      projectName: d.name,
                    });
                  }
                }
              }
              console.log(!this.projectId||type,this.projectUpdate)
            },
            this
          )
        },
      },
      watch:{
        projectPageId:function(){
          this.projectDetailsGet();
        }
          // updateRemRatio:function(){
          // }
      }
  }
</script>

<style type="text/css" lang="less">
  .projectSettings_main{
    position: absolute;
    top: 5.78rem;
    left: 0;
    width: 100%;
    height: calc(100% - 5.78rem);
    min-height: 50rem;
    margin: 0 auto;
    overflow: hidden;
    // position: relative;
    // display: flex;
    // background: rgba(255, 255, 255, 0.85);
    background-image: url("../img/login/background_1.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    &.ja{
      .btn_box{
        .btn1,.btn2,.btn3{
          width: initial;
          padding: 0 0.5rem;
        }
      }
    }
    // padding: 15.63rem 0 0 16.23rem;
    .cont_box{
      display: flex;
      // align-items: center;
      justify-content: center;
      // padding-top: 8rem;
      height: calc(100% - 0rem);
    }
    .cont_left{
      margin-top: 7rem;
      .p1{
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: rgba(58, 99, 111, 1);
        .i{
          margin-right: 0.5rem;
          color: #FF0101;
        }
      }
      .form_box{
        margin-top: 2.04rem;
        .form_item{
          display: flex;
          align-items: center;
          margin-bottom: 3.36rem;
          .icon{
            display:inline-block;
            margin-right: 1.84rem;
            width: 3.29rem;
            height: 3.29rem;
            // width: 4.54rem;
            // height: 4.14rem;
            &.btn{
              background-image: url('../img/icon/icon7.png');
              cursor: pointer;
              width: 4.54rem;
              height: 4.14rem;
              margin-right: 0.79rem;
            }
          }
          .icon4{
            background-image: url('../img/icon/icon4.png');
          }
          .icon5{
             cursor: pointer;
            background-image: url('../img/icon/icon5.png');
            width: 3.36rem;
            height: 3.88rem;
          }
          .icon6{
            background-image: url('../img/icon/icon6.png');
          }
          .icon7{
            background-image: url('../img/icon/icon7.png');
          }
          .el-input__inner{
            padding-left: 1.67rem;
            width: 30rem;
            height: 4rem;line-height: 4rem;
            border: 0.1rem solid #3A636F;
            border-radius: 0.5rem;
            background-color: rgba(0,0,0,0);
            
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3A636F;
          }
          .el-input__prefix{
            width: 1.8rem;height: 1.8rem;
            top: 0.96rem;left: 0.79rem;
            .icon{
              width: 100%;
            }
          }
          .el-input__suffix{
            height: 4.12rem;line-height: 4.12rem;
            right: 1.49rem;
          }
          .span{
            margin-top: -0.2rem;
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3A636F;
            position: relative;
            top: -0.2rem;
          }
          .el-input .el-select__caret{
            font-size: 1.8rem;
            color: rgba(58, 99, 111, 1);
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
    .cont_right{
      margin-left: 18.9rem;
      .p1{
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: rgba(58, 99, 111, 1);
        .i{
          color: #FF0101;
          margin-right: 0.5rem;
        }
      }
      .flex_box{
        display: flex;
        margin-top: 2.1rem;
        margin-bottom: 6.05rem;
        .icon{
            margin-right: 2.02rem;
            width: 3.42rem;
            height: 3.42rem;
            &.btn{
              background-image: url('../img/icon/btn_bg1.png');
              cursor: pointer;
            }
          }
          .icon8{
            background-image: url('../img/icon/icon8.png');
          }
          .icon9{
            background-image: url('../img/icon/icon9.png');
          }
      }
    }
    
    .btn_box{
      // position: absolute;
      // bottom: 12.28rem;
      // left: 0;
      margin-top: 7rem;
      display: flex;
      align-items: center;
      justify-content: center;
      // margin-top: 1.75rem;
      // margin: 0rem 24.65rem 0  16.67rem;
      width: 100%;
      .btn1{
        width: 8.3rem;
        height: 3.5rem;line-height: 3.5rem;
        background: #F4FBFD;
        border: 0.09rem solid #3A636F;
        border-radius: 0.26rem;
        text-align: center;
        
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3A636F;
        cursor: pointer;
        user-select: none;
        margin-right: 5rem;
      }
      .btn2{
        width: 8.3rem;
        height: 3.5rem;line-height: 3.5rem;
        background: #00C6FF;
        border: 0.09rem solid #00C6FF;
        border-radius: 0.26rem;
        text-align: center;

        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #FFFFFF;
        cursor: pointer;
        user-select: none;
      }
      .btn3{
        width: 8.38rem;
        height: 3.53rem;
        line-height: 3.53rem;
        background: rgba(255, 0, 0, 1);
        border: 0.09rem solid rgba(255, 0, 0, 1);
        border-radius: 0.26rem;
        text-align: center;
        margin-right: 5rem;
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #FFFFFF;
        cursor: pointer;
        user-select: none;
      }
    }
    .project_completed{
      position: fixed;
      top: 0;right: 0;left: 0;bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      
      .bg{
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0);
        z-index: -1;
        opacity: 0.5;
      }
      .form_box{
        position: relative;
        width: 36.51rem;
        height: 18.09rem;
        padding-top: 2.83rem;
        background: #FFFFFF;
        border: 0px solid #3A636F;
        border-radius: 0.2rem;
        opacity: 0.9;
        .span{
          font-family: Calibri;
          color: #3A636F;
          text-align: center;
          width: 23.22rem;
          font-weight: 400;
          font-size: 1.8rem;
          color: #4C717C;
          margin: auto;
        }
        .btn_box2{
          // position: absolute;
          // bottom: 0rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 5.07rem;
          // margin: 4.47rem auto 0;
          // width: 26.69rem;
          
          .btn2{
            width: 6.25rem;
            height: 2.63rem;
            background: #00C6FF;
            border-radius: 0.2rem;

            line-height: 2.63rem;
            border: 0.09rem solid #00C6FF;
            text-align: center;
            // font-family: Calibri;
            // font-weight: normal;
            // color: #FFFFFF;
            cursor: pointer;
            user-select: none;

            font-family: Calibri;
            font-weight: 400;
            font-size: 1.8rem;
            color: #FFFFFF;
          }
        }
      }
    }

    
    
  }
  .location_dialog {
      .maplnglatForm{
        display: flex;
      }
      .el-dialog__header {
        padding: 0px 20px 0 30px;
        height: 50px;
        line-height: 50px;
        border: 1px solid rgba(232, 232, 232, 1);
      }
      // .el-dialog__title{
      //   font-size: 1.8rem;
      // }
      .el-button {
        padding: 8px 20px;
        // font-size: 1.8rem;
      }
      .el-dialog__footer {
        padding: 18px 0 20px;
      }
      .el-dialog__footer {
        text-align: center;
      }
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
      .el-dialog__body {
        padding: 11px 30px 0px 30px;
      }
      .lampAmapWrapper_box {
        position: relative;
        .IPAZAH-content-container,.yNHHyP-marker-view{
          &:focus-visible{
            outline: none;
          }
        }
        .lm_img_mover{
          transform: translateY(15px);
        }

        .markerClass{
          transform: translate(0px,-40px);
          padding: 10px 20px;
          margin-right: 20px;
          font-size: 14px;
          color: #888888;
          background: #fff;
        }
        .screenMap {
          position: absolute;
          top: 20px;
          left: 40px;
          width: 250px;
          z-index: 1;
          line-height: 50px;
          i {
            font-size: 20px;
            cursor: pointer;
          }
        }
        .map_icon_location {
          cursor: pointer;
          position: absolute;
          right: 10px;
          bottom: 185px;
          z-index: 100;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(255, 255, 255, 0.9);
          border-radius: 3px;
          border: 1px solid #ccc;
          box-shadow: 1px 1px 10px 0 #ccc;
          .icon-location {
            font-size: 30px;
          }
        }
        .screenMap_ul {
          position: absolute;
          top: 63px;
          left: 40px;
          width: 250px;
          box-sizing: border-box;
          background-color: #fff;
          z-index: 1;
          border: 1px solid #dcdfe6;
          max-height: 350px;
          .screenMap_li {
            height: 32px;
            line-height: 32px;
            padding-left: 30px;
            cursor: pointer;

            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &:hover {
              background-color: #eee;
            }
          }
        }
      }
      #lampAmapWrapper,#lampAmapWrapper1 {
      width: 100%;
      min-height: 36rem;
      .google_Location_box {
        width: 40px;
        height: 40px;
        background: #fff;
        transform: translate(-10px,60px);
        .google_Location {
          // display: none;
          background: #fff
            url(http://webapi.amap.com/theme/v1.3/markers/b/loc_gray.png) 50% 50%
            no-repeat;
          width: 40px;
          height: 40px;
          border: 1px solid #ccc;
          cursor: pointer;
          transform: translate(-8px, -3px);
        }
        .circular {
          height: 25px;
          width: 25px;
          animation: loading-rotate 2s linear infinite;
          .path {
            animation: loading-dash 1.5s ease-in-out infinite;
            stroke-dasharray: 90, 150;
            stroke-dashoffset: 0;
            stroke-width: 2;
            stroke: #409eff;
            stroke-linecap: round;
          }
        }
      }
      .lamp_coordinate_en {
        // width: 200px
        // display: none;
        position: absolute;
        line-height: 30px;
        width: 600px;
        top: 10px;
        left: 45px;
        > span {
          display: inline-block;
          padding: 0 20px;
          margin-right: 20px;
          font-size: 14px;
          color: #888888;
          background: #fff;
          span {
            span {
              color: #fc8440;
            }
          }
          > :first-child {
            margin-right: 10px;
          }
        }
        > i {
          position: relative;
          top: 12px;
          font-size: 30px;
          z-index: 1;
          cursor: pointer;
        }
      }
      .lamp_coordinate {
        // width: 200px
        // display: none;
        position: absolute;
        line-height: 40px;
        width: 450px;
        top: -4px;
        left: 45px;
        > span {
          display: inline-block;
          padding: 0 20px;
          margin-right: 20px;
          font-size: 14px;
          color: #888888;
          background: #fff;
          span {
            span {
              color: #fc8440;
            }
          }
          > :first-child {
            margin-right: 10px;
          }
        }
        > i {
          position: relative;
          top: 12px;
          font-size: 30px;
          z-index: 1;
          cursor: pointer;
        }
      }
      .my-div-icon {
        .imgBox {
          width: 100%;
          height: 100%;
          .img {
            width: 100%;
          }
          .lapm-option-edit-wrap {
            position: absolute;
            left: 40px;
            top: -4px;
            vertical-align: middle;
            .lapm-option-edit-inner-wrap {
              display: flex;
              // width:404px;
              width: 409px;
              height: 40px;
              .list-title {
                box-sizing: border-box;
                padding: 10px 18px 10px 20px;
                display: flex;
                justify-content: space-between;
                width: 302px;
                height: 40px;
                line-height: 20px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 2px 4px 0px rgba(129, 129, 129, 0.12);
                border-radius: 2px;
                p {
                  span {
                    font-size: 14px;
                    font-family: PingFang-SC-Medium;
                    &.key {
                      color: #888;
                    }
                    &.val {
                      color: #1890ff;
                    }
                  }
                }
              }
              i {
                display: inline-block;
                width: 30px;
                height: 30px;
                border-radius: 15px;
                margin-top: 5px;
                cursor: pointer;
                &.certain {
                  margin-left: 22px;
                  // background: url("./src/img/certain_icon.png") no-repeat
                  background: url("../img/certain_icon.png") no-repeat
                    center;
                }
                &.cancel {
                  margin-left: 20px;
                  background: url("../img/cancel_icon.png") no-repeat
                    center;
                }
              }
            }
          }
        }
      }
    }
    }
</style>